import React, { useState, useEffect } from 'react';
import './Header.css';
import { FaBars, FaTimes, FaHome, FaMapMarkedAlt, FaEnvelope, FaHotel, FaCar, FaPlane } from 'react-icons/fa';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import { useLocalContext } from '../../context/LocalContext';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { webinfo } = useLocalContext();
  const isHome = location.pathname === '/';

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const handleNavigate = (path) => {
    setMenuOpen(false);
    navigate(path);
  };

  const navLinks = [
    { label: 'Home', path: '/', icon: <FaHome /> },
    { label: 'Flights', path: '/flight', icon: <FaPlane /> },
    { label: 'Packages', path: '/packages', icon: <FaMapMarkedAlt /> },
    { label: 'Cars', path: '/carrentals', icon: <FaCar /> },
    { label: 'Hotels', path: '/hotels', icon: <FaHotel /> },
    { label: 'Contact', path: '/contact', icon: <FaEnvelope /> },
  ];

  return (
    <motion.header
      className={`site-header ${scrolled ? 'site-header--scrolled' : ''} ${isHome && !scrolled ? 'site-header--hero' : ''}`}
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
    >
      <div className="site-header__inner">
        <motion.div
          className="site-header__logo"
          onClick={() => handleNavigate('/')}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          <img
            src={`${process.env.PUBLIC_URL}/logo-wordmark${isHome && !scrolled ? '-light' : ''}.png`}
            alt={webinfo.name || 'bowwowbasket.com'}
            className="site-header__logo-img"
          />
        </motion.div>

        <nav className="site-header__nav">
          {navLinks.map((link) => (
            <button
              key={link.path}
              type="button"
              className={`site-header__link ${location.pathname === link.path ? 'active' : ''}`}
              onClick={() => handleNavigate(link.path)}
            >
              {link.icon}
              <span>{link.label}</span>
            </button>
          ))}
        </nav>

        <div className="site-header__actions">
          <button
            type="button"
            className="site-header__menu-btn"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            {menuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {menuOpen && (
          <motion.div
            className="site-header__mobile"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.35 }}
          >
            {navLinks.map((link, i) => (
              <motion.button
                key={link.path}
                type="button"
                className="site-header__mobile-link"
                onClick={() => handleNavigate(link.path)}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: i * 0.05 }}
              >
                {link.icon} {link.label}
              </motion.button>
            ))}
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};

export default Header;
